import cn from 'classnames';
import styles from './ProductImage.module.scss';

/**
 * Akamai image policy name: @url https://nestle.atlassian.net/wiki/spaces/DEVCEN/pages/95879479/Akamai+IM+Policies
 * Add more as needed so we know what we are using...
 */
type AkamaiImagePolicy = 'small' | 'medium' | 'large' | 'productPdpSafeZone';

export type ProductImageProps = {
  image: { url: string; alt: string } | undefined;
  /** The `<img width=X>` to help prevent FOUC */
  width: number;
  loading: 'lazy' | 'eager';
  imagePolicy?: {
    /** The name of the Akamai image policy */
    policyId: AkamaiImagePolicy;
    targetWidth?: number;
    /** @default 1 */
    density?: 1 | 2;
  };
  class?: string;
};

// TODO: Move to shared
export default function ProductImage({
  image,
  loading = 'lazy',
  width,
  imagePolicy,
  class: className,
  ...rest
}: ProductImageProps) {
  const {
    policyId = 'small',
    targetWidth = 200,
    density = 1
  } = imagePolicy ?? {};

  if (!image || !image.url) return null;

  const { url, alt } = image;
  const params = new URLSearchParams({
    impolicy: policyId,
    imwidth: targetWidth.toString(),
    imdensity: density.toString()
  });
  const src = new URL(url, 'https://foo.com'); // need a valid URL, but won't be used
  src.search = params.toString();
  const relativeSrc = `${src.pathname}${src.search}`;

  return (
    <div class={cn(styles.container, className)} {...rest}>
      {url && (
        <img
          src={relativeSrc}
          alt={alt}
          loading={loading}
          width={width}
          class={styles.image}
        />
      )}
    </div>
  );
}
